export enum DrawType {
  // 抠图
  cutting = 1001,
  // 商品主图
  productMainImage = 1002,
  // 商品详情
  productDetails = 1003,
  // 海报
  marketingPoster = 1004,
  // 商详重绘
  detailsRedraw = 1005,
}

// export enum ItemType {
//   image = '1',
//   logo = '2',
//   title = '3',
//   text = '4',
//   textbox = '4',
//   'i-text' = '4',
//   rect = '5',
//   circle='6',
//   triangle='7',
//   polygon='8',
//   group='9',
//   line='10',
//   arrow='11',
//   thinTailArrow='12',
// }

export enum ItemType {
  image = '1',
  logo = '2',
  title = '3',
  text = '4',
  hoverUnits = '5',
}
